import { useEffect, useState } from 'react';
import { useApi } from '../api/api-provider';
import { useSession } from '../session/session-provider';

const IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/webp'];

/** Private, scanned raster only. Identity changes abort work and never reuse another tenant's blob URL. */
export function useBrandingAsset(assetId: string | null | undefined, purpose: 'logo' | 'hero', revision = 0) {
  const api = useApi();
  const session = useSession();
  const key = `${session.tenantCode}:${session.user?.subject ?? ''}:${assetId ?? ''}:${revision}`;
  const [result, setResult] = useState<{ key: string; url?: string; error: boolean }>({ key, error: false });
  useEffect(() => {
    const controller = new AbortController(); let ownedUrl: string | undefined;
    setResult({ key, error: false });
    if (assetId) void api.getBrandingAsset(session.toApiSession(), assetId, { signal: controller.signal }).then((blob) => {
      if (controller.signal.aborted) return;
      const maximum = purpose === 'logo' ? 256 * 1024 : 2 * 1024 * 1024;
      if (!IMAGE_TYPES.includes(blob.type) || blob.size === 0 || blob.size > maximum) throw new Error('branding_asset_invalid');
      ownedUrl = URL.createObjectURL(blob); setResult({ key, url: ownedUrl, error: false });
    }).catch(() => { if (!controller.signal.aborted) setResult({ key, error: true }); });
    return () => { controller.abort(); if (ownedUrl) URL.revokeObjectURL(ownedUrl); };
  }, [api, key, assetId, purpose]);
  return result.key === key ? result : { key, url: undefined, error: false };
}
